import Button, * as Btn from '@lib/components/Button';
import TitleBar, * as ITitleBar from '@lib/components/TitleBar';
import { ScheduleProps } from '@lib/containers/Schedule';
import * as React from 'react';
import { INativeNavigator, ISchedule } from 'types';
import './Schedule.css';


declare var Waves: any;

interface IScheduleState {
  schedules: ISchedule[];
  schedulesOtherChannel: ISchedule[];
  showEdit: boolean;
  showTrash: boolean;
  modified: boolean;
  isStart: boolean;
  idSchedule: string;
}

interface IDay {
  id: number;
  letter: string;
}

class Schedule extends React.Component<ScheduleProps, IScheduleState> {

  public constructor(props: ScheduleProps) {
    super(props);
    const schedules: ISchedule[] = [];
    const schedulesOtherChannel: ISchedule[] = [];
    if (this.props.site && this.props.site.thermostatSchedule && this.props.temp) {
      for (const schedule of this.props.site.thermostatSchedule) {
        if (schedule.channel === this.props.temp.no.toString()) {
          schedules.push(schedule);
        }else {
          schedulesOtherChannel.push(schedule);
        }
      }
    }
    this.state = {
      idSchedule: '',
      isStart: true,
      modified: false,
      schedules,schedulesOtherChannel, showEdit: false, showTrash: false,
    };
  }

  public componentDidMount() {
    Waves.attach('div.listItem', 'waves-light');
  }

  /**
   * Fired when user click on menu hamburger button
   * @param event 
   */
  public onMenuClick(event: React.MouseEvent<HTMLDivElement>) {
    if (!this.state.modified || confirm(this.props.i18n.Common.confirmCancel)) {
      this.props.onGoBack();
    }
  }

  /**
   * Fired when user wants to validate all modification
   */
  public onValidateClick() {
    // Check that there is maximum 35 schedules
    if (this.state.schedules.length > 35) {
      /* tslint:disable:no-empty */
      (navigator as INativeNavigator).notification.alert(this.props.i18n.Schedule.maxSchedule, () => { }, 'Smart TX');
      return;
    }

    // Check if there is alaways a day
    for (const schedule of this.state.schedules) {
      if (schedule.days === "0") {
        /* tslint:disable:no-empty */
        (navigator as INativeNavigator).notification.alert(this.props.i18n.Schedule.errorDayMandatory, () => { }, 'Smart TX');
        return;
      }
    }

    // Check time order
    for (const schedule of this.state.schedules) {
      if (schedule.startTime >= schedule.endTime) {
        /* tslint:disable:no-empty */
        (navigator as INativeNavigator).notification.alert(this.props.i18n.Schedule.errorStartAfterEnd, () => { }, 'Smart TX');
        return;
      }
    }


    this.props.onSave(this.props.site!.device!.id, this.props.site!.name, this.state.schedules.concat(this.state.schedulesOtherChannel));
  }

  /**
   * Fired when user click on Trash bottom button
   * @param event 
   */
  public onTrashClick(event: React.MouseEvent<HTMLDivElement>) {
    this.setState({ showTrash: !this.state.showTrash });
  }

  public onAddSchedule(event: React.MouseEvent<HTMLDivElement>) {
    const schedules: ISchedule[] = JSON.parse(JSON.stringify(this.state.schedules));
    let maxId: number = 0;

    for (const schedule of schedules) {
      if (parseFloat(schedule.id) > maxId) {
        maxId = parseFloat(schedule.id);
      }
    }
    schedules.push({
      channel: (this.props.temp.no).toString(),
      days: "0",
      endTime: '10:00',
      id: (maxId + 1).toString(),
      startTime: '09:00',
    });
    this.setState({ schedules, modified: true });
  }

  /**
   * Check if a day is in the mask
   * @param day 
   * @param mask 
   */
  public checkDay(day: number, mask: string) {
    // tslint:disable-next-line:no-bitwise
    return (Math.pow(2, day) & parseFloat(mask)) === Math.pow(2, day);
  }

  /**
   * Fired wehn user click on a day to select or deselect it
   * @param idSchedule 
   * @param idDay 
   */
  public selectDay(idSchedule: string, idDay: number) {
    const schedules: ISchedule[] = JSON.parse(JSON.stringify(this.state.schedules));
    for (const schedule of schedules) {
      if (schedule.id === idSchedule) {
        const days = schedule.days;
        if (this.checkDay(idDay, days)) {
          schedule.days = (parseFloat(days) - Math.pow(2, idDay)).toString();
        }
        else {
          schedule.days = (parseFloat(days) + Math.pow(2, idDay)).toString();
        }
        break;
      }
    }
    this.setState({ schedules });
  }

  /**
   * Used to delete a schedule
   * @param idSchedule 
   * @param isStart 
   * @param currentValue 
   */
  public deleteSchedule(idSchedule: string) {
    if (this.state.showTrash) {
      const schedules: ISchedule[] = [];
      for (const schedule of this.state.schedules) {
        if (schedule.id !== idSchedule) {
          schedules.push(schedule);
        }
      }
      this.setState({ schedules, modified: true });
    }
  }

  public onSuccess(value: any) {
    if (value === undefined) { return; }
    let hh = value.getHours();
    let mm = value.getMinutes();
    if (hh < 10) { hh = "0" + hh; }
    if (mm < 10) { mm = "0" + mm; }
    // This formats your string to HH:MM:SS
    const time = hh + ":" + mm;
    const schedules: ISchedule[] = JSON.parse(JSON.stringify(this.state.schedules));
    for (const schedule of schedules) {
      if (schedule.id === this.state.idSchedule) {
        if (this.state.isStart) {
          schedule.startTime = time
        }
        else {
          schedule.endTime = time
        }
        break;
      }
    }
    this.setState({ schedules, modified: true });
  }

  public onError(error: any) { // Android only
    // alert('Error: ' + error);
  }

  /**
   * Used to select times ofr a schedule
   */
  public promptTime(idSchedule: string, isStart: boolean, currentValue: string) {

    if (datePicker.isFake) {
      // Web 
      const time: string = '' + prompt("Saisissez l'heure", currentValue);

      if (!/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(time)) { return };

      const schedules: ISchedule[] = JSON.parse(JSON.stringify(this.state.schedules));
      for (const schedule of schedules) {
        if (schedule.id === idSchedule) {
          if (isStart) {
            schedule.startTime = time
          }
          else {
            schedule.endTime = time
          }
          break;
        }
      }
      this.setState({ schedules, modified: true });
    } else {
      // Native apps
      const currentTime = new Date();
      const schedules: ISchedule[] = JSON.parse(JSON.stringify(this.state.schedules));
      for (const schedule of schedules) {
        if (schedule.id === idSchedule) {
          currentTime.setHours(parseInt(currentValue.split(':')[0], 10));
          currentTime.setMinutes(parseInt(currentValue.split(':')[1], 10));
          break;
        }
      }
      const options = {
        allowFutureDates: true,
        allowOldDates: true,
        cancelButtonLabel: this.props.i18n.Schedule.dateTimeCancelButtonLabel,
        cancelText: this.props.i18n.Schedule.dateTimeCancel,
        date: currentTime,
        doneButtonLabel: this.props.i18n.Schedule.dateTimeDoneButtonLabel,
        is24Hour: true,
        mode: 'time',
        okText: this.props.i18n.Schedule.dateTimeOk,
        titleText: this.props.i18n.Schedule.dateTimeTitle,
      };
      datePicker.show(options, this.onSuccess.bind(this), this.onError.bind(this));
      this.setState({ idSchedule, isStart });
    }
  }

  public render() {

    if (this.props.site === undefined || this.props.site.thermostatSchedule === undefined) {
      window.location.pathname = '/';
      window.location.hash = '';
      return null;
    }

    const i18n = this.props.i18n.Schedule;

    const days: IDay[] = [];
    for (let i = 1; i <= 6; i++) {
      days.push({
        id: i,
        letter: this.props.i18n.Common['day_' + i]
      });
    }
    days.push({
      id: 0,
      letter: this.props.i18n.Common.day_0
    });

    return (
      <div className="standardPage scheduleList">
        <div className="scheduleList" style={{
          alignItems: 'center', display: "flex", flexDirection: "column",
        }}>
          <TitleBar
            leftIcon={ITitleBar.ICO_CHEVRON_LEFT}
            onLeftButtonClick={this.onMenuClick.bind(this, this.state)}
            title={i18n.title}
            rightIcon={this.props.saving ? ITitleBar.ICO_CHECK_ROTATING : ITitleBar.ICO_CHECK}
            onRightButtonClick={this.onValidateClick.bind(this, this.state)}
          />
          <div id="scheduleList">
            {this.state.schedules.map((schedule: ISchedule) => {
              return (
                <div key={schedule.id} className="schedule">
                  <div onClick={this.deleteSchedule.bind(this, schedule.id)} className={this.state.showTrash ? 'scheduleTrash' : 'scheduleMode'} />
                  <div className="scheduleInfo">
                    <div className="scheduleTimes">
                      <div className={'startTime ' + (schedule.startTime >= schedule.endTime ? 'scheduleTimesError' : '')} onClick={this.promptTime.bind(this, schedule.id, true, schedule.startTime)}>{schedule.startTime}</div>
                      <div className={'endTime ' + (schedule.startTime >= schedule.endTime ? 'scheduleTimesError' : '')} onClick={this.promptTime.bind(this, schedule.id, false, schedule.endTime)}>{schedule.endTime}</div>
                    </div>
                    <div className="scheduleDays">
                      {days.map((day: IDay) => {
                        return (<div onClick={this.selectDay.bind(this, schedule.id, day.id)}
                          className={'scheduleDay ' + (this.checkDay(day.id, schedule.days) ? 'scheduleDaySelected' : 'scheduleDayUnselected')}
                          key={day.id}>{day.letter}
                        </div>)
                      })}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          <Button labelFA='trash' type={Btn.BTN_TYPE_CIRCLE_UP} onClick={this.onTrashClick.bind(this, 'trash')} />
          <Button labelFA='plus' type={Btn.BTN_TYPE_CIRCLE} onClick={this.onAddSchedule.bind(this, -1)} />
        </div>
      </div>
    );
  }
}

export default Schedule;



// WEBPACK FOOTER //
// ./src/pages/Schedule.tsx